//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ModalWithTitleBar from '~/components/Shared/ModalWithTitleBar'

export default {
  name: 'ModalUsersWithoutEmail',
  components: { ModalWithTitleBar },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: this.value,
    }
  },
  watch: {
    value() {
      this.active = this.value
    },
  },
  methods: {
    finalize() {
      this.active = !this.active
      this.$emit('confirmed')
      this.$emit('input', this.active)
    },

    close() {
      this.active = !this.active
      this.$emit('close')
      this.$emit('input', this.active)
    },
  },
}
